import { EMPTY_OBJ, EMPTY_ARR, DEFAULT_LOCALE } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useVocabularyList = (queryVariables = {}, queryConfig = {}) => {
  const { data: vocabulary = [], ...queryResult } = useResourceList(
    { name: 'vocabulary', api: api.vocabulary },
    queryVariables,
    queryConfig,
  );

  return {
    vocabulary,
    latestVocabulary: queryResult.latestData,
    ...queryResult,
  };
};

export const useAllVocabularies = ({ languageCode }, queryConfig = {}) => {
  const queryResult = useQuery(['vocabulary', { languageCode }], api.vocabulary.getAllByLanguage, {
    ...queryConfig,
  });

  return {
    vocabularies: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

export const useVocabulary = ({ id, locale = DEFAULT_LOCALE }, queryConfig = {}) => {
  const queryResult = useQuery(['vocabulary', { id, locale }], api.vocabulary.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    vocabulary: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'vocabulary' });

export const useDeleteVocabulary = createMutation(api.vocabulary.remove);

export const useCreateVocabulary = createMutation(api.vocabulary.create);

export const useSaveVocabulary = createMutation(api.vocabulary.save);

export const usePublishVocabulary = createMutation(api.vocabulary.publish);

export const useUpdateVocabulary = createMutation(api.vocabulary.update);
